import React from 'react';
import { Metadata } from '@latitude/metadata';
import { SITE_URL } from '@/utils/constants';
import Layout from '@/components/layout';
import HowToApplyPageHeader from '@/components/HowToApply/header/PageHeader';
import HowToApplySteps from '@/components/HowToApply/steps/HowToApplySteps';
import HeaderImage from '@/../static/images/credit-cards/how-to-apply/hero_image.webp';

const HowToApply = ({ location }) => {
  return (
    <Layout location={location}>
      <main className="navigation-spacer">
        <Metadata
          title={`What You Need to Apply For a Credit Card | Latitude Financial`}
          description={`Find out what you'll need to apply for a Latitude credit card, including eligibility, proof of income, and our application process.`}
          keywords="how to apply credit card"
          canonical={`${SITE_URL}${location.pathname}`}
        />

        <HowToApplyPageHeader
          heading={`What you'll need to apply for a Low Rate Mastercard`}
          subheading={`Before you start, check that you meet the eligibility criteria and have your details and documents handy.`}
          imageUrl={HeaderImage}
          
        />

        <HowToApplySteps
          getStartedUrl={'/credit-cards/low-rate'}
          ctaID="low-rate-how-to-apply"
        />
      </main>
    </Layout>
  );
};

export default HowToApply;
